import { useState } from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { useUnreadCount } from '../api/notification-queries'
import {
  formatUnreadBadgeDisplay,
  notificationsBellAriaLabel,
} from '../lib/format-unread-badge'
import {
  notificationBellBadgeSx,
  notificationBellBadgeTextSx,
  notificationBellIconWrapSx,
} from '../styles/notificationBellStyles'
import { NotificationBellGlyph } from './NotificationBellGlyph'
import { NotificationPanel } from './NotificationPanel'

export function NotificationBell() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const { data: unreadCount = 0 } = useUnreadCount()

  const open = Boolean(anchorEl)

  function handleOpen(e: React.MouseEvent<HTMLElement>) {
    setAnchorEl(e.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const badgeDisplay = formatUnreadBadgeDisplay(unreadCount)

  return (
    <>
      <IconButton
        onClick={handleOpen}
        aria-label={notificationsBellAriaLabel(unreadCount)}
        aria-haspopup="true"
        aria-expanded={open}
        data-testid="sensemaker-bell-icon"
        sx={{
          color: 'rgba(255,255,255,0.85)',
          '&:hover': { color: '#ffffff', bgcolor: 'rgba(255,255,255,0.08)' },
          borderRadius: '8px',
          width: 40,
          height: 40,
        }}
      >
        <Box sx={notificationBellIconWrapSx}>
          <NotificationBellGlyph sx={{ fontSize: 24 }} />
          {unreadCount > 0 ? (
            <Box component="span" sx={notificationBellBadgeSx} data-testid="sensemaker-bell-badge">
              <Box component="span" sx={notificationBellBadgeTextSx(badgeDisplay)}>
                {badgeDisplay}
              </Box>
            </Box>
          ) : null}
        </Box>
      </IconButton>

      <NotificationPanel anchorEl={anchorEl} open={open} onClose={handleClose} />
    </>
  )
}
